"use client";

import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeader from "@/components/main/CPageHeader";
import { Card, TypographyStylesProvider } from "@mantine/core";
import { IconBriefcase, IconUsersPlus } from "@tabler/icons-react";
import Link from "next/link";

const AboutPage = ({ dictionary, aboutPageData }) => {
  const items = [
    { title: dictionary.home, href: "/" },
    { title: aboutPageData?.landing?.title },
  ];
  return (
    <>
      <CPageHeader
        links={items}
        title={aboutPageData?.landing?.title}
        subTitle={aboutPageData?.landing?.description}
        showInput={false}
      />
      <div className="flex flex-col items-center">
        <div className="max-w-[800px] mx-auto">
          <TypographyStylesProvider>
            <div
              dangerouslySetInnerHTML={{
                __html: aboutPageData?.landing?.content,
              }}
              className="my-10"
            ></div>
          </TypographyStylesProvider>
        </div>
        <div className="md:flex mx-3 md:space-x-3 max-w-[800px] mb-10">
          <Card withBorder padding={"xl"} radius={"lg"} className="w-full mt-3">
            <IconUsersPlus className="text-primary" size="30" />
            <h4 className="m-0 my-3 text-grayCustom">
              {aboutPageData?.firstCard?.title}
            </h4>
            <p className="m-0 mb-3 text-greyDark">
              {aboutPageData?.firstCard?.description}
            </p>
          </Card>
          <Card withBorder padding={"xl"} radius={"lg"} className="w-full mt-3">
            <IconBriefcase className="text-primary" size="30" />
            <h4 className="m-0 my-3 text-grayCustom">
              {aboutPageData?.secondCard?.title}
            </h4>
            <p className="m-0 mb-3 text-greyDark">
              {aboutPageData?.secondCard?.description}
            </p>
          </Card>
        </div>
      </div>
    </>
  );
};

export default WebLayout(AboutPage);
